export enum Permissions {
  CAN_USE = 'can_use',
  // GUEST='guest',
  MEMBER = 'member',
}
